{
  "viewBox": [-2900.0, -2900.0, 5800, 5800],
  "slot_radii": {
    "standard": 256,
    "large": 384
  },
  "placements": [
    {
      "key": "PatientChoice",
      "cx": 927,
      "cy": -391,
      "rotation": 52.7,
      "size": 1.0
    },
    {
      "key": "AllIn",
      "cx": -1443,
      "cy": 641,
      "rotation": 44.5,
      "size": 1.0
    },
    {
      "key": "Persevere",
      "cx": -164,
      "cy": 1283,
      "rotation": -18.1,
      "size": 1.0
    },
    {
      "key": "GrowConquest",
      "cx": -1022,
      "cy": 69,
      "rotation": -23.3,
      "size": 1.5
    },
    {
      "key": "ShowPiety",
      "cx": -70,
      "cy": -308,
      "rotation": 0.0,
      "size": 1.0
    },
    {
      "key": "PunishWeakness",
      "cx": -754,
      "cy": 1194,
      "rotation": 43.4,
      "size": 1.0
    },
    {
      "key": "SeekModesty",
      "cx": 307,
      "cy": 969,
      "rotation": -32.7,
      "size": 1.0
    },
    {
      "key": "SeekHumility",
      "cx": -1379,
      "cy": -1149,
      "rotation": -23.5,
      "size": 1.0
    },
    {
      "key": "GrowFaith",
      "cx": -284,
      "cy": -944,
      "rotation": 0.0,
      "size": 1.5
    },
    {
      "key": "SeekWonder",
      "cx": 469,
      "cy": -1196,
      "rotation": 0.0,
      "size": 1.0
    },
    {
      "key": "Overpower",
      "cx": -904,
      "cy": 679,
      "rotation": 30.9,
      "size": 1.0
    },
    {
      "key": "ImpulsiveChoice",
      "cx": -1626,
      "cy": -361,
      "rotation": -49.6,
      "size": 1.0
    },
    {
      "key": "GrowPolis",
      "cx": 392,
      "cy": -625,
      "rotation": 30.2,
      "size": 1.0
    },
    {
      "key": "GrowLegend",
      "cx": -988,
      "cy": -591,
      "rotation": -17.1,
      "size": 1.0
    },
    {
      "key": "BringPeace",
      "cx": 906,
      "cy": 775,
      "rotation": -46.4,
      "size": 1.0
    },
    {
      "key": "GrowCommunity",
      "cx": -257,
      "cy": 202,
      "rotation": 0.0,
      "size": 1.0
    },
    {
      "key": "ShowMight",
      "cx": -257,
      "cy": 747,
      "rotation": 0.0,
      "size": 1.0
    },
    {
      "key": "GrowBounty",
      "cx": 442,
      "cy": 132,
      "rotation": 31.8,
      "size": 1.5
    }
  ]
}
